import Link from "next/link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";
import { routes } from "src/shared/routes";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Cheez-It Bowl Pass",
    description:
      "For members of Jordan Davis' fan club, get exclusive access to the Cheez-It Bowl and get field passes to see Jordan Davis perform at halftime! Be sure to login with the same email associated with the Fan Club.",
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [];

export const REGISTER_TERMS_AND_CONDITIONS = () => {
  return (
    <>
      By checking this box you agree to receive notifications and offers from FC
      Sports and to the{" "}
      <Link target="_blank" href="https://www.attend.tech/terms-of-use">
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link target="_blank" href="https://www.attend.tech/privacy-policy">
        Privacy Policy
      </Link>
      .
    </>
  );
};

export const TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive notifications regarding your
      purchase and to the Terms of Use and Privacy Policy.{" "}
      <Link target="_blank" href="https://www.attend.tech/terms-of-use">
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link target="_blank" href="https://www.attend.tech/privacy-policy">
        Privacy Policy
      </Link>
      .
    </>
  );
};
